// extracted by mini-css-extract-plugin
export default {"dataTable":"data-table_dataTable__Kw+OE","inputError":"data-table_inputError__X8PYx"};